import './App.css';
import FinancialDashboard from './FinancialDashboard';


function App() {
  return (
    <div className="App">
      <main>
        <FinancialDashboard />
      </main>
    </div>
  );
}

export default App;
